import { AxiosError, AxiosResponse } from 'axios';
import { MfaCodeResendType, MfaCodeVerifyType } from 'interfaces';
import { useMutation } from 'react-query';
import { AuthAPI } from 'services/auth.api';

type MfaVerifyResponse = {
  token: string;
};

type MfaResendResponse = {
  status?: string;
};

export enum MfaErrorStatus {
  // Verify
  MISSING_CODE_OR_TOKEN = 'MISSING_CODE_OR_TOKEN',
  CODE_INVALID_OR_EXPIRED = 'CODE_INVALID_OR_EXPIRED',
  ACCOUNT_TEMPORARILY_BLOCKED = 'ACCOUNT_TEMPORARILY_BLOCKED',

  // Resend
  NO_ACTIVE_CODE_TO_RESEND = 'NO_ACTIVE_CODE_TO_RESEND',
  RESEND_LIMIT_REACHED = 'RESEND_LIMIT_REACHED',
  RESEND_TOO_SOON = 'RESEND_TOO_SOON',
  LAST_CODE_RESENT = 'LAST_CODE_RESENT',
}

export type ApiError = {
  status?: MfaErrorStatus | string;
  remainingSeconds?: string;
};

/**
 * Hook pour vérifier le code MFA
 * Retourne le token JWT si le code est valide
 */
export const useMfaCodeVerify = () => {
  return useMutation<
    AxiosResponse<MfaVerifyResponse>,
    AxiosError<ApiError>,
    MfaCodeVerifyType
  >((payload) => AuthAPI.verify2fa(payload));
};

/**
 * Hook pour renvoyer le code MFA par email
 */
export const useMfaCodeResend = () => {
  return useMutation<
    AxiosResponse<MfaResendResponse>,
    AxiosError<ApiError>,
    MfaCodeResendType
  >((payload) => AuthAPI.resend2fa(payload));
};
